<template>
    <div class="bg-white p-6 shadow-md rounded-lg">
        <h2 class="text-lg font-semibold text-gray-700 mb-4 flex items-center">
            <font-awesome-icon :icon="['fas', 'user-graduate']" class="text-green-600 mr-2" />
            Application Types
        </h2>
        <div v-if="hasData">
            <apexchart type="bar" height="300" :options="chartOptions" :series="chartSeries" />
        </div>
        <div v-else class="text-gray-500 text-center py-16">
            <div class="text-4xl mb-2">📊</div>
            <div>There is no data to show</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ApplicationTypeChart",
    props: {
        data: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        hasData() {
            return this.data && this.data.length > 0;
        },
        chartSeries() {
            return [{
                name: 'Applications',
                data: this.data.map(item => item.count)
            }];
        },
        chartOptions() {
            return {
                chart: {
                    type: 'bar',
                    toolbar: { show: false },
                },
                xaxis: {
                    categories: this.data.map(item => this.formatApplicationType(item.application_type)),
                },
                colors: ['#70AD47'],
                plotOptions: {
                    bar: {
                        columnWidth: '60%',
                    },
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                        return val;
                    },
                },
                tooltip: {
                    y: {
                        formatter: (val) => `${val} Applications`,
                    },
                },
                grid: {
                    borderColor: '#f1f5f9',
                }
            };
        }
    },
    methods: {
        formatApplicationType(type) {
            const typeMap = {
                'Transfer Applicant': 'Transfer',
                'Napo Applicant': 'NAPO',
                'Direct Applicant': 'Direct',
                'Further studies (bridging student)': 'Bridging'
            };
            return typeMap[type] || type;
        }
    }
};
</script>
